import { render, staticRenderFns } from "./ProfileGrid.vue?vue&type=template&id=499ba5cc&scoped=true&"
import script from "./ProfileGrid.vue?vue&type=script&lang=js&"
export * from "./ProfileGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499ba5cc",
  null
  
)

export default component.exports